// extracted by mini-css-extract-plugin
export default {"main":"tutorial_main__J1UjV","ps":"tutorial_ps__HNGlO"};